import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'allCategories',
      'mainCategories',
      'highSchoolCategories',
      'localCategories',
    ]),
    noSubItems() {
      if (this.mainCategories) {
        let items = this.mainCategories.filter(parent => {
          let hasChildren =
            this.allCategories.findIndex(c => c.parent_id === parent.id) > -1;
          return !hasChildren;
        });
        return items;
      }
      return [];
    },
  },
  methods: {
    urlByCategoryId(id) {
      if (this.allCategories) {
        const category = this.allCategories.find(c => c.id == id);
        const url = `/broadcasts/${category.id}/${this.seoName(category.name)}`;
        return url;
      }
      return '';
    },
    nameByCategoryId(id) {
      if (this.allCategories.length && id) {
        const category = this.allCategories.find(c => c.id == id);
        const name = category.name;
        return name;
      }
      return '';
    },
    categoryExists(id) {
      if (this.allCategories.length && id) {
        const category = this.allCategories.find(c => c.id == id);
        if (category) {
          return true;
        }
        return false;
      }
    }
  },
  created() {
    this.$store.dispatch('getCategories');
  },
};
